import {i18n} from "../../../i18n";
import _ from "lodash";
import DataSourceSelect from "@/Shared/Reports/Wizard/DataSourceSelect";
import CancelReportGenerationDialog from "@/Shared/Reports/Wizard/CancelReportGenerationDialog";
import ReportGenerationConfirmation from "@/Shared/Reports/Wizard/ReportGenerationConfirmation";
import DrawerLayout from "@/Shared/DrawerLayout";
import ControlPanel from "@/Shared/ControlPanel";
import {mapActions, mapState} from 'pinia';
import {ReportsStore} from "@/Store/Reports/ReportsStore";

const Mixin = {

    components: {
        DrawerLayout, ControlPanel, DataSourceSelect, CancelReportGenerationDialog,
        ReportGenerationConfirmation
    },

    props:{
        reportType: {
            type: Object,
        },
        academicPeriodRecords: {
            type: Object,
            required: true,
        },
    },

    data(){
        return {
            e2: 1,

            valid: true,

            dataSources: [],

            initialForm: {},

            reportConfigurations:[],

            reportConfiguration:[],

            showDataSourceCancelGenerationDialog: false,

            dataSourceSelectors: 1,

            flags: {
                saving: false,
            },

            rules: {
                reportTitle: [
                    v => !!v || i18n.t('reports.create_form.required_fields.report_title'),
                ],

                academicPeriod: [
                    v => !!v || i18n.t('reports.create_form.required_fields.academic_period'),
                ],
            },
        }
    },

    created() {
        this.initialForm = _.cloneDeep(this.form);
        this.setReportTypeName(this.reportType.name);
    },

    methods: {
        /**
         *
         */
        ...mapActions(ReportsStore, [
            'searchDataSources',
            'storeReport',
            'searchReportConfiguration',
            'setReportTypeName'
        ]),

        /**
         * Gets available data sources
         *
         * @returns {Promise<void>}
         */
        async getDataSources() {
            try {
                let type = _.get(this.reportType, 'id'),
                    reportSubtype = this.form.report_subtype,
                    academicPeriod = this.form.academic_period;

                let criteria = {
                    report_type: type,
                    academic_period: academicPeriod,
                    data_source_subtype_id: reportSubtype,
                };

                let configurationsRespond= await this.searchReportConfiguration(criteria);

                this.reportConfigurations = _.get(configurationsRespond, 'data._embedded.report_type_configurations');

                this.reportConfiguration =  _.first(this.reportConfigurations)

                this.reportConfiguration = _.get(this.reportConfiguration,'data_sources')

                if(this.reportConfiguration != undefined  &&  this.reportConfiguration.length > 0){
                    let response = await this.searchDataSources(criteria);

                    this.dataSources = _.get(response, 'data._embedded.data_sources');
                }
                //TODO show error toast if there is no configuration available


            } catch (ex) {
                this.toast().error(
                    this.$t('reports.create_form.error_fetching_data_sources'),
                    this.$t('reports.create_form.error_fetching_data_sources_message'),
                );

                console.error('Fetch data sources exception', ex);
            }
        },

        /**
         * Gets data-source type translation
         *
         * @param type
         * @returns {*}
         */
        getDataSourceTypeTranslation(type) {
            return i18n.t(`reports.data_source_types.${type}`);
        },

        /**
         * @returns {Promise<void>}
         */
        async saveReport() {
            try {
                this.flags.saving = true;

                await this.storeReport(_.cloneDeep(this.form),this.reportTypeName);

                this.goBackToReportsIndex();

                this.toast().success(
                    this.$t('reports.create_form.success_store_title', {report: this.form.title}),
                    this.$t('reports.create_form.success_store_message'),
                );

            } catch (ex) {

                this.toast().error(
                    this.$t('reports.create_form.error_store_title'),
                    this.$t('reports.create_form.error_store_message'),
                );

                console.error('Report store exception', ex.response);

            } finally {

                this.flags.saving = false;
            }
        },

        /**
         * Sets data sources selected from child components
         *
         * @param newValue
         * @param oldValue
         */
        setSelectedDataSources(newValue, oldValue) {
            this.deleteDataSourceSelected(oldValue);

            this.form.data_sources.push(newValue);
        },

        /**
         * Delete given value from selected data sources
         *
         * @param value
         */
        deleteDataSourceSelected(value) {
            let index = value !== '' && this.form.data_sources.findIndex(
                (dataSourceSelected) => dataSourceSelected === value
            );

            index !== false && this.form.data_sources.splice(index, 1);
        },

        /**
         * Shows confirmation dialog if form has been updated
         *
         * @returns {boolean}
         */
        cancelReportCreation() {
            !_.isEqual(this.initialForm, this.form)
                ? this.showDataSourceCancelGenerationDialog = true
                : this.goBackToReportsIndex();
        },
        /**
         * Closes dialog and goes back to index
         */
        confirmCancelReportCreation() {
            this.showDataSourceCancelGenerationDialog = false;

            this.goBackToReportsIndex();
        },
        /**
         * Redirect to report index when canceling creation process
         */
        goBackToReportsIndex() {
            this.$inertia.get(route('reports.index', {'type': this.reportTypeRouteParameter}));
        },

    },

    computed:{
        ...mapState(ReportsStore,['reportTypeName']),

        breadcrumbsItems() {
            return [
                {
                    text: i18n.t(`reports.types.${this.reportTypeRouteParameter}`),
                    disabled: true,
                },
                {
                    text: i18n.t('reports.create'),
                    disabled: false,
                    href: route('reports.generate', {'type': this.reportTypeRouteParameter}),
                },
            ];
        },
        /**
         * Gets data-source types
         *
         * @returns {Array}
         */
        dataSourceTypes() {

            if(!this.dataSources)
                return [];

            return _.uniq(_.map(this.dataSources, (value) => value.class));
        },
        /**
         * Gets selected data source
         *
         * @returns {Array}
         */
        dataSourceTitles() {

            if(!this.form.data_sources.length > 0)
                return [];

            return _.filter(this.dataSources,
            (dataSource) => {
                let found = false;

                for (let data_sources of this.form.data_sources){
                    found = data_sources.id == dataSource.id

                    if(found) break;
                }

                return found;
            });
        },

        dataSourcesByTypes(){
            let dataSourcesObjectByType = {};

            _.forEach(this.dataSourceTypes, (dataSourceType)=>{
                dataSourcesObjectByType[dataSourceType] =
                    _.filter(this.dataSources,function (value){return value.class == dataSourceType;});

            })

            return dataSourcesObjectByType;
        },

        /**
         *
         * @returns {*}
         */
        academicPeriodTitle() {
            let academicPeriod = _.filter(this.academicPeriods,
                (academicPeriod) => academicPeriod.id === this.form.academic_period
            ).first();

            return academicPeriod ? _.get(academicPeriod, 'name') : '';
        },

        /**
         *
         */
        academicPeriods() {
            return _.get(this.academicPeriodRecords, '_embedded.academic_periods');
        },

        /**
         *
         * @returns {*}
         */
        reportTypeRouteParameter() {
            return _.get(this.reportType, 'route_type_parameter');
        },

        requireReportTypes(){
            let neededReportTypes=[]

            _.forEach(this.reportConfiguration, (configuration)=>{
                neededReportTypes.push(configuration.class)
            });

            return neededReportTypes;
        },

        /**
         *
         * @returns {*}
         */
        sortAcademicPeriods() {

            const academicsPeriods = this.academicPeriods.sort((initialAcademicPeriod, finalAcademicPeriod) => {
                // Extraer el año inicial de cada periodo
                const academicPeriodInitial = parseInt(initialAcademicPeriod.name.split("-")[0], 10);
                const academicPeriodFinal = parseInt(finalAcademicPeriod.name.split("-")[0], 10);
                // Comparar los años iniciales
                return academicPeriodFinal - academicPeriodInitial;
            });

            return academicsPeriods;
        },

    }
};
export default Mixin;
